const randomize = require("randomatic");
export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Task Name",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "itineraryRef_contains",
      label: "Itinerary Ref",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "assignedToName_contains",
      label: "Assigned To",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "assignedByName_contains",
      label: "Assigned By",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TaskStatusMultiFilter"),
    props: {
      filterName: "taskStatus_eq",
      label: "Status",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "estimatedStart",
      label: "Due Date Between",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "project_contains",
      label: "Project",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "notes_contains",
      label: "Notes",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "nextAction_contains",
      label: "Follow Up",
      filterValue: null,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/plugins/task-tracker/filters.js